import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Button, Form, Radio, Space, Typography, Switch, message } from 'antd';
import './index.less';
import { showMedProject, messageSettingsApi, unCheckMessagesApi } from '@services/MedProject';
import { pageFormItemWithoutLabelGridLayout } from '@utils/property';
import UserMessage from './components/UserMessage';
import MessageReview from './components/MessageReview';
import PageHeader from '@components/PageHeader/PageHeader';
import { useProjectContext } from '@/contexts/ProjectContext';
import { WORKSPACE_PARENT_PATH, WORKSPACE_ROUTE_BASE } from '@/layouts/workspaceConfig';

const { Text } = Typography;

export default function MedProjectSetting() {
    const navigate = useNavigate();
    const params = useParams();
    const { id: projectContextId, name: projectName } = useProjectContext();

    const medProjectId = (params?.projectId ?? params?.id) || 0; // 项目 ID

    useEffect(() => {
        document.title = '页面设置-医项目';
    }, []);

    const [form] = Form.useForm();

    const [userMessageVisible, setUserMessageVisible] = useState(false);
    const [messageReviewVisible, setMessageReviewVisible] = useState(false);
    const [unCheckMessagesCount, setUnCheckMessagesCount] = useState({});

    const getProject = async id => {
        const res = await showMedProject(id);
        if (res.status_code === 200) {
            const data = res.data;
            if (data.settings) {
                form.setFieldsValue({
                    settings: JSON.parse(data.settings),
                });
            }
        }
    };

    const onFinish = async values => {
        console.log('Success:', values);
        const res = await messageSettingsApi({ id: medProjectId, settings: values.settings ? JSON.stringify(values.settings) : undefined });
        if (res.status_code === 200) {
            message.success('提交成功');
        }
    };

    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    const onCancel = () => {
        navigate(-1);
    };

    const getUnCheckMessages = async () => {
        const res = await unCheckMessagesApi({ projectId: medProjectId });
        if (res.status_code === 200 && res.data) {
            setUnCheckMessagesCount(res.data);
        }
    };

    useEffect(() => {
        if (!!medProjectId) {
            getProject(medProjectId);
            getUnCheckMessages();
        }
    }, []);

    return (
        <>
            <PageHeader title="页面设置" breadcrumb={[{ label: '医项目', path: WORKSPACE_PARENT_PATH }, { label: projectName, path: `${WORKSPACE_ROUTE_BASE}/${projectContextId}` }, '页面设置']} />

            <div className="page-route-body">
                <div className="main-content-body page-setting-form">
                    <Form form={form} onFinish={onFinish} onFinishFailed={onFinishFailed}>
                        <div className="form-subtitle">板块显示设置</div>

                        <Form.Item name={['settings', 'userMessageHidden']} label="【留言墙】是否前台显示该模块" initialValue={1} className="medproject-setting-form">
                            <Radio.Group>
                                <Radio value={0}>显示</Radio>
                                <Radio value={1}>隐藏</Radio>
                            </Radio.Group>
                        </Form.Item>

                        <Form.Item name={['settings', 'contributionHidden']} label="【我要贡献】是否前台显示该模块" initialValue={1} className="medproject-setting-form">
                            <Radio.Group>
                                <Radio value={0}>显示</Radio>
                                <Radio value={1}>隐藏</Radio>
                            </Radio.Group>
                        </Form.Item>

                        <div className="form-subtitle">【留言墙】前台显示设置</div>

                        <Form.Item
                            className="medproject-setting-form "
                            name={['settings', 'userMessageEnabled']}
                            label="用户留言功能"
                            valuePropName="checked"
                            getValueProps={value => ({
                                checked: value === 1,
                            })}
                            getValueFromEvent={value => (value ? 1 : 0)}
                            style={{ marginBottom: '5px' }}
                        >
                            <Switch checkedChildren="开启" unCheckedChildren="关闭" />
                        </Form.Item>
                        <Form.Item noStyle shouldUpdate>
                            {({ getFieldValue }) => {
                                const open = getFieldValue(['settings', 'userMessageEnabled']);
                                return !!open ? (
                                    <>
                                        <div className="message-review">
                                            <Button type="primary" onClick={() => setMessageReviewVisible(true)}>
                                                留言审核
                                            </Button>
                                            <Text type={unCheckMessagesCount?.user > 0 ? 'danger' : 'secondary'} style={{ margin: '0 5px' }}>
                                                待审核{unCheckMessagesCount?.user}条
                                            </Text>
                                            <Text type="secondary">打开该功能，用户在前台即可留言，需要审核展示才在前台显示</Text>
                                        </div>
                                    </>
                                ) : (
                                    <div className="message-review">
                                        <Text type="secondary">关闭该功能，用户在前台不可留言。也不展示用户的留言</Text>
                                    </div>
                                );
                            }}
                        </Form.Item>

                        <Form.Item
                            className="medproject-setting-form"
                            label="内置留言功能"
                            valuePropName="checked"
                            getValueProps={value => ({
                                checked: value === 1,
                            })}
                            getValueFromEvent={value => (value ? 1 : 0)}
                            style={{ marginTop: '24px' }}
                        >
                            <div>
                                <Button type="primary" onClick={() => setUserMessageVisible(true)}>
                                    内置留言
                                </Button>
                                <Text style={{ margin: '0 5px' }}>内置留言{unCheckMessagesCount?.system}条</Text>
                                <Text type="secondary">可内置留言，内置留言用户头像/昵称系统会自动生成</Text>
                            </div>
                        </Form.Item>

                        <div className="page-form-foot-operations">
                            <Space size="large">
                                <Button type="primary" size="large" htmlType="submit">
                                    提交
                                </Button>
                                <Button type="default" size="large" onClick={onCancel}>
                                    取消
                                </Button>
                            </Space>
                        </div>
                    </Form>
                </div>
            </div>

            <UserMessage userMessageVisible={userMessageVisible} setUserMessageVisible={setUserMessageVisible} />
            <MessageReview messageReviewVisible={messageReviewVisible} setMessageReviewVisible={setMessageReviewVisible} />
        </>
    );
}
